export interface SendActivationCodeRequest {
    Email: string;
    Mobile: string;
    ActivationWay: number;
    Token: string;
}
export interface SendActivationCodeResponse {
    Id: string;
    ActivationCodeExpireDate: number;
    LoginType: string;
    ActivationWay: number;
}
export interface VerifyActivationCodeRequest {
    Id: string;
    VerifyCode: string;
    ActivationWay: number;
}
export interface ForgetPasswordRequest {
    Id: string;
    VerifyCode: string;
    UserName: string;
    Password: string;
    Token: string;
}
export interface LoginRequest {
    UserName: string,
    Password: string,
    Token: string
}
export interface SendEmailConfirmCodeRequest {
    Email: string,
}
export interface SendEmailConfirmCodeResponse {
    Id: string,
}
export interface VerifyEmailConfirmCodeRequest {
    Id: string,
    VerifyCode: string,
}
export interface VerifyEmailConfirmResponse {
    Id: string,
}
export enum ActivationWay{
    Login = 0,
    Register = 1,
    ForgetPassword = 2,
}